import { theme } from 'configs/styled';
import React from 'react';
import Divider from '../components/Divider';
import DriverPortalLayout from '../components/DriverPortalLayout';
import HeaderPortal from '../components/HeaderPortal';
import TextBold from '../components/TextBold';
import TextRegular from '../components/TextRegular';
import Title from '../components/Title';

export interface IMainPageProps {}

const PrivacyPolicyPage: React.FC<IMainPageProps> = () => {
  return (
    <>
      <HeaderPortal />
      <DriverPortalLayout>
        <Title>นโยบายคุ้มครองข้อมูลส่วนบุคคล</Title>
        <Divider />
        <div>
          <TextBold
            fontSize={'16px'}
            color={theme.palettes.black85}
            margin={'0px 0px 8px'}
            display={'block'}
          >
            การลงทะเบียนความสนใจและลงทะเบียนสมัคร All NOW ไรเดอร์
          </TextBold>
          <TextRegular color={theme.palettes.black85}>
            เนื่องจาก บริษัท ออลล์ นาว โลจิสติกส์ จำกัด และบริษัท ออลล์ นาว
            แมนเนจเม้นท์ จำกัด (“บริษัท”) ได้ตระหนักถึงความสำคัญของข้อมูลส่วน
            บุคคลของท่าน ที่ได้มอบให้แก่บริษัทด้วยความไว้วางใจ และบริษัทมี
            ความจำเป็นต้องปฏิบัติตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
            พ.ศ.2562 เพื่อเป็นการรับรองสิทธิของบุคคลที่จะต้องได้รับความคุ้มครอง
            เกี่ยวกับการเก็บรวบรวม ใช้ เปิดเผย (“ประมวลผล”) ข้อมูลส่วนบุคคล
            โดยเอกสารฉบับนี้มีวัตถุประสงค์เพื่อแจ้งวิธีการเก็บรวบรวม ใช้
            และเปิดเผยข้อมูลส่วนบุคคลของท่าน บริษัทขอให้ท่านโปรดอ่านเอกสาร
            ฉบับนี้เพื่อรับทราบและทำความเข้าใจในวัตถุประสงค์ที่บริษัทได้เก็บรวบรวม
            ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่าน
          </TextRegular>
          <Divider />
          <TextBold
            fontSize={'16px'}
            color={theme.palettes.black85}
            margin={'0px 0px 8px'}
            display={'block'}
          >
            1. วัตถุประสงค์และฐานในการประมวลผลข้อมูล
          </TextBold>
          <TextBold
            color={theme.palettes.black85}
            margin={'0px 0px 8px'}
            display={'block'}
          >
            1.1. วัตถุประสงค์ในการประมวลผลข้อมูล
          </TextBold>
          <TextRegular
            color={theme.palettes.black85}
            margin={'0px 0px 8px'}
            display={'block'}
          >
            เนื่องจากบริษัทได้ทำการเปิดให้ลงทะเบียนความสนใจและลงทะเบียนสมัคร All
            NOW ไรเดอร์ในการขนส่งสินค้า บริษัทจึงมีความจำเป็นในการจัดเก็บ
            ข้อมูลส่วนบุคคลของท่านกรณีที่ท่านได้กดส่งข้อมูลในแบบฟอร์มดังกล่าว
            เพื่อการติดต่อสื่อสาร ประชาสัมพันธ์ จัดส่งข้อมูลที่เกี่ยวข้องกับ
            การรับสมัคร All NOW ไรเดอร์ รวมถึงขั้นตอนการอบรม
            และทดสอบขั้นตอนการทำงาน และการอื่นใดอันจำเป็นในการคัดเลือก ผู้สมัคร
            Rider ทั้งนี้ บริษัทได้รับข้อมูลส่วนบุคคลจากท่านโดยตรง
          </TextRegular>
          <TextBold
            color={theme.palettes.black85}
            margin={'0px 0px 8px'}
            display={'block'}
          >
            1.2. ฐานในการประมวลผลข้อมูล
          </TextBold>
          <TextRegular
            color={theme.palettes.black85}
            margin={'0px 0px 8px'}
            display={'block'}
          >
            บริษัทดำเนินการประมวลผลข้อมูลส่วนบุคคลของท่านภายใต้ฐานดังต่อไปนี้
          </TextRegular>
          <ul>
            <li>
              <TextBold color={theme.palettes.black85} margin={'0 px'}>
                ฐานจำเป็นเพื่อประโยชน์โดยชอบด้วยกฎหมาย (Legitimate Interest):
              </TextBold>
              <br />
              <TextRegular color={theme.palettes.black85}>
                บริษัทอาจนำข้อมูลส่วนบุคคลของท่านไปใช้ในการประมวลผล
                เพื่อการคัดกรองผู้ที่มีคุณสมบัติครบถ้วนเพื่อติดต่อเข้าทำสัญญาขนส่งสินค้า
                อันเป็นกรณีฐานจำเป็นเพื่อประโยชน์โดยชอบด้วยกฎหมาย ตามมาตรา 24
                (5) ของพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.2562
              </TextRegular>
            </li>
            <li>
              <TextBold color={theme.palettes.black85} margin={'0 px'}>
                ฐานการปฏิบัติตามกฎหมาย (Legal Obligation):
              </TextBold>
              <br />
              <TextRegular color={theme.palettes.black85}>
                บริษัทอาจนำข้อมูลส่วนบุคคลของท่านไปใช้ในการประมวลผลเพื่อ
                การปฏิบัติตามกฎหมายที่กำกับดูแล เช่น
                พระราชบัญญัติหลักทรัพย์และตลาดหลักทรัพย์ พ.ศ.2535,
                พระราชบัญญัติป้องกันและปราบปรามการฟอกเงิน พ.ศ.2542
                และกฎหมายอื่นที่บริษัทต้องอยู่ภายใต้บังคับให้ส่งข้อมูลส่วนบุคคล
                เช่น ประมวลวิธีพิจารณาความแพ่ง
                ที่ให้อำนาจศาลสั่งให้คู่ความส่งเอกสาร หรือข้อมูลในการพิจารณาคดี
                เป็นต้น อันเป็นกรณีฐานการปฏิบัติตามกฎหมายตามมาตรา 24 (6)
                ของพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.2562
              </TextRegular>
            </li>
          </ul>
          <Divider />
          <TextBold
            fontSize={'16px'}
            color={theme.palettes.black85}
            margin={'0px 0px 8px'}
            display={'block'}
          >
            2. ข้อมูลส่วนบุคคลที่จะทำการประมวลผลและระยะ เวลาในการเก็บรวบรวม
          </TextBold>
          <TextBold
            color={theme.palettes.black85}
            margin={'0px 0px 8px'}
            display={'block'}
          >
            2.1. ระยะเวลาในการเก็บรวบรวม
          </TextBold>
          <ul>
            <li>
              <TextRegular color={theme.palettes.black85}>
                กรณีที่ไม่ผ่านการคัดเลือกบริษัทจะทำการจัดเก็บข้อมูลของท่าน
                เป็นระยะเวลาประมาณ 2 ปี นับจากวันที่ได้รับข้อมูล
              </TextRegular>
            </li>
            <li>
              <TextRegular color={theme.palettes.black85}>
                กรณีที่ผ่านการคัดเลือกบริษัทจะทำการจัดเก็บข้อมูลของท่านเป็น
                ระยะเวลาประมาณ 10 ปี นับจากวันที่สิ้นสุดการให้บริการ ทั้งนี้
              </TextRegular>
            </li>
            <li>
              <TextRegular color={theme.palettes.black85}>
                เมื่อพ้นกำหนดระยะเวลาข้างต้น บริษัทจะทำการลบ
                หรือทำให้ข้อมูลส่วนบุคคลไม่สามารถระบุตัวบุคคลได้
              </TextRegular>
            </li>
          </ul>
          <div style={{ marginBottom: '8px' }}>
            <TextBold
              color={theme.palettes.black85}
              margin={'0px 0px 8px'}
              display={'block'}
            >
              2.2. ประเภท/รายการข้อมูลส่วนบุคคล
            </TextBold>
          </div>
          <ul>
            <li>
              <TextRegular color={theme.palettes.black85}>
                รายละเอียดส่วนบุคคล เช่น คำนำหน้าชื่อ ชื่อ นามสกุล
                วันเดือนปีเกิด เพศ ภาพถ่าย
                ข้อมูลเกี่ยวกับบัตรที่ออกให้โดยทางราชการ (เช่น
                บัตรประจำตัวประชาชน ทะเบียนรถยนต์
                พ.ร.บ.(ประกันภัยรถยนต์ภาคบังคับ) ใบขับขี่และใบอนุญาตอื่นๆ
                เป็นต้น) ประวัติอาชญากรรม ประกัน ลายมือชื่อ
                และข้อมูลระบุตัวตนอื่นๆ การร้องเรียน การให้คำแนะนำติชม
              </TextRegular>
            </li>
            <li>
              <TextRegular color={theme.palettes.black85}>
                ข้อมูลการติดต่อ เช่น หมายเลขโทรศัพท์มือถือ ที่อยู่ตามทะเบียนบ้าน
                ที่อยู่ปัจจุบัน ที่อยู่อีเมล์ ไลน์ และข้อมูลอื่นๆ
                ที่มีลักษณะเดียวกัน
              </TextRegular>
            </li>
            <li>
              <TextRegular color={theme.palettes.black85}>
                ข้อมูลสุขภาพ เช่น ข้อมูลการฉีดวัคซีน ข้อมูลโรคประจำตัว
                และข้อมูลอื่นๆ ที่มีลักษณะเดียวกัน
              </TextRegular>
            </li>
            <li>
              <TextRegular color={theme.palettes.black85}>
                ข้อมูลของบุคคลที่ 3 เช่น หนังสือยินยอมให้ใช้รถ
                (กรณีไม่ใช่รถของตัวเอง) สำเนาบัตรประชาชนของเจ้าของรถ
              </TextRegular>
            </li>
          </ul>
          <Divider />
          <TextBold
            fontSize={'16px'}
            color={theme.palettes.black85}
            margin={'0px 0px 8px'}
            display={'block'}
          >
            3. การเปิดเผยข้อมูลส่วนบุคคลให้แก่บุคคลภายนอก
          </TextBold>
          <TextRegular color={theme.palettes.black85}>
            บริษัทอาจทำการเปิดเผยข้อมูลส่วนบุคคลให้แก่บุคคลภายนอกเท่าที่จำเป็น
            เพื่อให้เป็นไปตามวัตถุประสงค์หลักหรือวัตถุประสงค์ที่เกี่ยวข้องกับการประมวลผลข้อมูลส่วนบุคคล
            โดยบริษัทอาจส่งข้อมูลของท่านไปยังบริษัทลูกค้า คู่ค้า
            พันธมิตรทางธุรกิจ ผู้ให้บริการและที่ปรึกษาวิชาชีพของบริษัท
            หน่วยงานกำกับ หน่วยงานของรัฐบาล หรือหน่วยงานที่มีหน้าที่ดูแล เช่น
            สำนักงานคณะกรรมการกำกับหลักทรัพย์และตลาดหลักทรัพย์,
            สำนักงานตรวจเงินแผ่นดิน, สำนักงานป้องกันและปราบปรามการฟอกเงิน,
            สำนักงานคณะกรรมการคุ้มครองผู้บริโภค, สำนักงานตำรวจแห่งชาติ,
            กระทรวงยุติธรรม, บุคคลใด ๆ ที่บริษัทต้องเปิดเผยเท่าที่กฎหมาย
            หรือระเบียบที่เกี่ยวข้องกำหนด หรือเป็นไปตามคำสั่งศาล
            หรือกรณีได้รับความยินยอมจากท่านเรียบร้อยแล้ว
            และอาจมีการเปิดเผยเพื่อประโยชน์ในการดำเนินคดีของบริษัทเองด้วย
          </TextRegular>
          <Divider />
          <TextBold
            fontSize={'16px'}
            color={theme.palettes.black85}
            margin={'0px 0px 8px'}
            display={'block'}
          >
            4. ข้อมูลส่วนบุคคลของบุคคลที่สาม
          </TextBold>
          <TextRegular color={theme.palettes.black85}>
            หากท่านได้ให้ข้อมูลส่วนบุคคลของบุคคลที่สามแก่บริษัท เช่น ชื่อ
            นามสกุล รายละเอียดที่อยู่ และหมายเลขโทรศัพท์สำหรับการติดต่อฉุกเฉิน
            หรือการอ้างอิง รวมถึงกรณีนำส่งเอกสารยินยอมให้ใช้รถ
            ท่านจะต้องขอความยินยอมในการให้ข้อมูลส่วนบุคคลของบุคคลที่สาม
            แก่บริษัท และแจ้งรายละเอียดการประมวลผลข้อมูลส่วนบุคคล
            ตามเอกสารฉบับนี้แก่บุคคลที่สามก่อนหรือขณะนำส่งข้อมูลดังกล่าว
            แก่บริษัท
          </TextRegular>
          <Divider />
          <TextBold
            fontSize={'16px'}
            color={theme.palettes.black85}
            margin={'0px 0px 8px'}
            display={'block'}
          >
            5. สิทธิของเจ้าของข้อมูล
          </TextBold>
          <TextBold
            color={theme.palettes.black85}
            margin={'0px 0px 8px'}
            display={'block'}
          >
            ท่านมีสิทธิ
          </TextBold>
          <ul>
            <li>
              <TextRegular color={theme.palettes.black85}>
                สิทธิในการเพิกถอนความยินยอมให้บริษัทประมวลผล
                ข้อมูลส่วนบุคคลของท่าน
              </TextRegular>
            </li>
            <li>
              <TextRegular color={theme.palettes.black85}>
                สิทธิในการเข้าถึงและรับสำเนาข้อมูลส่วนบุคคลที่บริษัทได้เก็บรวบรวม
                ใช้ เปิดเผย
              </TextRegular>
            </li>
            <li>
              <TextRegular color={theme.palettes.black85}>
                สิทธิในการขอให้โอนย้ายข้อมูลส่วนบุคคลของท่าน
              </TextRegular>
            </li>
            <li>
              <TextRegular color={theme.palettes.black85}>
                สิทธิในการคัดค้านการประมวลผลข้อมูลส่วนบุคคลของท่าน
              </TextRegular>
            </li>
            <li>
              <TextRegular color={theme.palettes.black85}>
                สิทธิในการขอให้ลบ ทำลาย
                หรือทำให้ข้อมูลส่วนบุคคลของท่านซึ่งไม่อาจระบุตัวตนได้
              </TextRegular>
            </li>
            <li>
              <TextRegular color={theme.palettes.black85}>
                สิทธิในการระงับการใช้ข้อมูลส่วนบุคคลของท่าน
              </TextRegular>
            </li>
            <li>
              <TextRegular color={theme.palettes.black85}>
                สิทธิในการขอแก้ไขข้อมูลส่วนบุคคลของท่านให้ถูกต้องเป็นปัจจุบัน
                สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด
              </TextRegular>
            </li>
            <li>
              <TextRegular color={theme.palettes.black85}>
                สิทธิที่จะร้องเรียนในกรณีที่ท่านเห็นว่าถูกบริษัทหรือเจ้าหน้าที่
                หรือตัวแทนของบริษัทละเมิดสิทธิตามพระราชบัญญัติคุ้มครอง
                ข้อมูลส่วนบุคคล พ.ศ.2562
              </TextRegular>
            </li>
          </ul>
          <TextRegular color={theme.palettes.black85}>
            การร้องขอใด ๆ เพื่อการใช้สิทธิของท่านตามที่กล่าวข้างต้น
            จะต้องกระทำเป็นลายลักษณ์อักษร
            และบริษัทจะใช้ความพยายามอย่างดีที่สุดที่จะดำเนินการภายในระยะเวลา
            ที่สมเหตุสมผล และไม่เกินระยะเวลาที่กฎหมายกำหนด
            โดยบริษัทจะปฏิบัติตามข้อกำหนดทางกฎหมายที่เกี่ยวกับสิทธิของท่าน
            ในฐานะเจ้าของข้อมูลส่วนบุคคล ทั้งนี้
            อาจเกิดข้อจำกัดในการขอใช้สิทธิของ ท่านบางประการ
            โดยบริษัทจะทำการชี้แจงให้ท่านทราบหากไม่สามารถ
            ปฏิบัติตามคำร้องขอใช้สิทธิของท่านได้ โดยข้อจำกัดดังกล่าวเป็นไปตาม
            ที่พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 กำหนด
            การใช้สิทธิดังกล่าวข้างต้น บริษัทขอสงวนสิทธิ์ในการคิดค่าบริการใด ๆ
            ที่เกี่ยวข้องและจำเป็นต่อการเข้าดำเนินการเกี่ยวกับข้อมูลส่วนบุคคลตามที่ท่านร้องขอ
          </TextRegular>
          <Divider />
          <TextBold
            fontSize={'16px'}
            color={theme.palettes.black85}
            margin={'0px 0px 8px'}
            display={'block'}
          >
            6. การเปลี่ยนแปลงเอกสารแจ้งการประมวลผลข้อมูลส่วนบุคคล (Privacy
            Notice)
          </TextBold>
          <TextRegular color={theme.palettes.black85}>
            เพื่อให้เป็นไปตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.2562
            เอกสารแจ้งการประมวลผลข้อมูลส่วนบุคคล (Privacy Notice) ฉบับนี้
            อาจมีการแก้ไขเปลี่ยนแปลงในแต่ละคราว
            โดยบริษัทจะแสดงฉบับที่เป็นปัจจุบันไว้บนเว็บไซต์ของบริษัท
            หรือแจ้งเป็นลายลักษณ์อักษรต่อไป
          </TextRegular>
          <Divider />
          <TextBold
            fontSize={'16px'}
            color={theme.palettes.black85}
            margin={'0px 0px 8px'}
            display={'block'}
          >
            7. รายละเอียดเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล
          </TextBold>
          <TextRegular
            color={theme.palettes.black85}
            margin={'0px 0px 8px'}
            display={'block'}
          >
            หากมีเหตุร้องเรียนเกี่ยวกับข้อมูลส่วนบุคคลสามารถติดต่อประสานงานมายังเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลได้ในช่องทางดังนี้
          </TextRegular>
          <TextBold
            color={theme.palettes.black85}
            margin={'0px 0px 8px'}
            display={'block'}
          >
            7.1. เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล
          </TextBold>
          <TextRegular color={theme.palettes.black85}>
            เลขที่ 119 อาคารธาราสาทร ชั้น 8 ถนนสาทรใต้ แขวงทุ่งมหาเมฆ เขตสาทร
            กรุงเทพมหานคร 10120
            <br />
            Email Address:
            <a href="mailto:privacy@allnow.co.th">privacy@allnow.co.th</a>
          </TextRegular>
          <TextBold
            color={theme.palettes.black85}
            margin={'8px 0px 8px'}
            display={'block'}
          >
            7.2. ผู้ควบคุมข้อมูลส่วนบุคคล
          </TextBold>
          <TextRegular color={theme.palettes.black85}>
            บริษัท ออลล์ นาว โลจิสติกส์ จำกัด และบริษัท ออลล์ นาว แมนเนจเม้นท์
            จำกัด
            <br />
            เลขที่ 119 อาคารธาราสาทร ชั้น 8 ถนนสาทรใต้ แขวงทุ่งมหาเมฆ เขตสาทร
            กรุงเทพมหานคร 10120
            <br />
            Email Address:
            <a href="mailto:dpc@allnow.co.th">dpc@allnow.co.th</a>
          </TextRegular>
          <Divider />
          <TextRegular color={theme.palettes.black85}>
            หากท่านเห็นว่าการประมวลผลข้อมูลส่วนบุคคลของท่านไม่เป็นไปตาม
            พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.2562
            ท่านมีสิทธิที่จะร้องเรียนไปยังสำนักงานคณะกรรมการคุ้มครองข้อมูลส่วน
            บุคคล
            <br />
            <br />
            เอกสารแจ้งการประมวลผลข้อมูลส่วนบุคคล (Privacy Notice) ฉบับนี้
            ให้มีผลใช้บังคับในวันเดียวกันกับวันที่พระราชบัญญัติคุ้มครองข้อมูลส่วน
            บุคคล พ.ศ.2562 มีผลใช้บังคับทั้งฉบับ
          </TextRegular>
        </div>
      </DriverPortalLayout>
    </>
  );
};

export default PrivacyPolicyPage;
